import React, {Component} from 'react';
import './update_modal.sass';


class UpdateModal extends Component {

    constructor(props) {
        super(props);

        this.setRef = ref => {
            this.file = ref;
        }
    }

    render() {
        const {state, closeEditModal, startEditSubmit, documentChange, updatePdf} = this.props;
        const doc = state.document;
        return (
            <div>

                <div className="modal_update">
                    <div className="modal_update_container update_column">
                        <label className="title_update_product">Modifica Prodotto</label>

                            <div className="update_column margin_section">
                                <div className="upload-btn-wrapper-modal">
                                    <div className="row_upload_modal">
                                        <button className="btn_upload_modal">Seleziona</button>
                                        <label className="text_pdf">{doc.pdfName}</label>
                                    </div>
                                    <input className="pdf" value={this.setRef} type="file" name="myfile"
                                           onChange={updatePdf}
                                           ref={this.setRef} accept=".pdf"/>
                                </div>

                                <label className="title_update">Nome</label>
                                <input type="text" name="name" value={doc.name} placeholder="Nome"
                                       onChange={documentChange}/>
                                {doc.name.trim() === '' &&
                                <div className="help_block_update">Il nome è obbligatorio</div>
                                }


                                <label className="title_update title_margin">Descrizione</label>
                                <textarea className="description_update" type="text" placeholder="Descrizione"
                                          name="description"
                                          value={doc.description} onChange={documentChange}/>

                            </div>


                        <div className="all_width_update">
                            <button className="cancel_update" onClick={closeEditModal}>Annulla</button>
                            <button className="confirm_update" disabled={doc.name.trim() === ''} onClick={startEditSubmit}>Salva</button>
                        </div>
                    </div>
                </div>

            </div>
        );


    }


}

export default UpdateModal;